import React, { useState } from 'react';
import styled from 'styled-components';
import { useBetting } from '../../../../../../../Context/BettingContext';
import { sendNotfication } from '../../../../../../../Helper';

const Container = styled.div`
  width: 100%;
  background-color: #292d2e;
  font-family: 'Montserrat Alternates', sans-serif;
`;

const StatusBar = styled.div`
  background: rgb(50, 55, 56);
  color: white;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  font-weight: bold;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: rgb(240, 156, 6);
  }
`;

const StatusTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: bold;

  svg {
    width: 18px;
    height: 18px;
    fill: rgb(240, 156, 6);
  }
`;

const OddsContainerHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 90px 90px;
  gap: 0px;
  position: relative;
  padding: 4px 0px;
`;

const MarketContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: #292d2e;
`;

const MarketRow = styled.div`
  display: flex;
  flex-direction: column;
  background: ${props => (props.selected === 'no' ? '#292d2e' : props.selected === 'yes' ? '#292d2e' : '#292d2e')};
  border-radius: 4px;
  overflow: hidden;
  transition: background-color 0.3s ease;
  position: relative;
  margin-bottom: 8px;
  border: 1px solid rgb(50, 55, 56);
`;

const MarketHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: rgb(50, 55, 56);
  border-bottom: 1px solid rgb(50, 55, 56);
`;

const MarketTitle = styled.div`
  font-size: 11px;
  color: white;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const OddsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 90px 90px;
  gap: 0px;
  position: relative;
`;

const OddsBox = styled.div`
  display: flex;
  width: 90px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px;
  background: ${props => (props.type === 'no' ? '#FFB6C1' : '#72BBEF')};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${props => (props.disabled ? 0.6 : 1)};
  transition: background-color 0.2s ease;

  .odds {
    font-weight: bold;
    font-size: 10px;
    color: black;
  }

  .volume {
    font-size: 8px;
    color: black;
  }
`;

const BetSlip = styled.div`
  background: #292d2e;
  padding: 12px;
`;

const BetInputContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
`;

const OddsDisplay = styled.div`
  padding: 8px 16px;
  border: 1px solid rgb(50, 55, 56);
  border-radius: 4px;
  font-size: 12px;
  color: white;
  min-width: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .odds {
    font-weight: bold;
    font-size: 12px;
  }

  .volume {
    font-size: 8px;
    color: #cccccc;
    margin-top: 2px;
  }
`;

const AmountContainer = styled.div`
  flex: 1;
  display: flex;
  border: 1px solid rgb(50, 55, 56);
  border-radius: 4px;
  overflow: hidden;
  background: #292d2e;
`;
const BetInputc = styled.input`
  width: 60px;
  text-align: center;
  font-size: 14px;
  padding: 4px;
   border: 1px solid rgb(50, 55, 56);
  border-radius: 4px;
  color: white;
    background: #292d2e;
     font-family: 'Montserrat Alternates', sans-serif;
`;

const AdjustButton = styled.div`
  width: 40px;
  background: rgb(50, 55, 56);
  color: white;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const AmountInput = styled.input`
  width: 70px;
  text-align: center;
  font-size: 14px;
  padding: 4px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
  color: #000;
`;

const QuickAmounts = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 4px;
  margin-bottom: 12px;
`;

const QuickAmount = styled.div`
  padding: 6px;
  background: #292d2e;
  border: 1px solid rgb(50, 55, 56);
  border-radius: 2px;
  font-size: 10px;
  cursor: pointer;
  text-align: center;
  color: white !important;
`;

const Numpad = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 4px;
  margin-bottom: 12px;
  color: white !important;
  text-align: center;
`;

const NumpadButton = styled.div`
  padding: 12px;
  background: #292d2e;
  border: 1px solid rgb(50, 55, 56);
  border-radius: 2px;
  font-size: 12px;
  text-align: center;
  cursor: pointer;
  color: white;
`;

const ActionButtons = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  text-align: center;
`;

const Button = styled.div`
  padding: 12px;
  border-radius: 4px;
  text-align: center;
  font-size: 12px;
  cursor: pointer;
  border: 1px solid ${props => (props.variant === 'primary' ? 'rgb(240, 156, 6)' : 'rgb(50, 55, 56)')};
  background: ${props => (props.variant === 'primary' ? 'rgb(240, 156, 6)' : '#292d2e')};
  color: ${props => (props.variant === 'primary' ? 'black' : 'white')};
  font-weight: ${props => (props.variant === 'primary' ? 'bold' : 'normal')};
`;

const AcceptOddsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  font-size: 10px;
  color: white;
`;

// -------- helpers --------
const handleAmountChange = (currentAmount, change) => {
  const num = Number(currentAmount || 0);
  const next = num + change;
  return next < 0 ? '0' : String(next);
};

const FancyBetMobile = ({ matchData, fancyData = [] }) => {
  const [activeTab] = useState('All'); // reserved for future filtering
  const [selectedBets, setSelectedBets] = useState({});
  const [betAmounts, setBetAmounts] = useState({});
  const [acceptAnyOdds, setAcceptAnyOdds] = useState({});
  const { placeBets } = useBetting();

  // NEW: per-slip placing lock to avoid duplicate placements
  const [placingKeys, setPlacingKeys] = useState({});

  const quickAmounts = [100, 1000, 2000, 5000, 50000, 100000];

  const handleOddsClick = (market, type) => {
    const marketKey = `${market.marketName}-${type}`;
    const oppositeType = type === 'no' ? 'yes' : 'no';
    const oppositeKey = `${market.marketName}-${oppositeType}`;

    setSelectedBets(prev => {
      const next = { ...prev };
      delete next[oppositeKey];
      if (next[marketKey]) {
        delete next[marketKey];
      } else {
        next[marketKey] = { market, type };
      }
      return next;
    });

    if (!betAmounts[marketKey]) {
      setBetAmounts(prev => ({ ...prev, [marketKey]: '100' }));
    }
  };

  return (
    <Container>
      <StatusBar>
        <StatusTitle>
          <svg viewBox="0 0 24 24">
            <path d="M3.5,18.5L9.5,12.5L13.5,16.5L22,6.92L20.59,5.5L13.5,13.5L9.5,9.5L2,17L3.5,18.5Z" />
          </svg>
          Fancy Bet
        </StatusTitle>
      </StatusBar>

      <OddsContainerHeader>
        <div style={{ width: '100%', textAlign: 'center', color: 'white', fontSize: '10px', fontWeight: 'bold', padding: '8px 0' }} />
        <div style={{ width: '100%', textAlign: 'center', color: 'white', fontSize: '10px', fontWeight: 'bold', padding: '8px 0' }}>No</div>
        <div style={{ width: '100%', textAlign: 'center', color: 'white', fontSize: '10px', fontWeight: 'bold', padding: '8px 0' }}>Yes</div>
      </OddsContainerHeader>

      <MarketContainer>
        {fancyData.map((market) => {
          const noKey = `${market.marketName}-no`;
          const yesKey = `${market.marketName}-yes`;
          const selectedType = selectedBets[noKey] ? 'no' : selectedBets[yesKey] ? 'yes' : null;
          const isActive = market.statusName === 'active';

          return (
            <React.Fragment key={market.marketId}>
              <MarketRow selected={selectedType}>
                <MarketHeader>
                  <MarketTitle>
                    <span style={{ color: 'white', fontSize: '11px' }}>{market.marketName}</span>
                  </MarketTitle>
                </MarketHeader>

                <OddsContainer>
                  <div style={{ width: '100%', backgroundColor: 'transparent', padding: '8px 12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ color: 'white', fontSize: '11px' }}>{market.marketName}</span>
                    <span style={{ color: '#cccccc', fontSize: '12px' }}>ⓘ</span>
                  </div>

                  <OddsBox
                    type="no"
                    selected={!!selectedBets[noKey]}
                    onClick={() => handleOddsClick(market, 'no')}
                  >
                    <span className="odds">{market.runsNo}</span>
                    <span className="volume">{market.oddsNo}</span>
                  </OddsBox>

                  <OddsBox
                    type="yes"
                    selected={!!selectedBets[yesKey]}
                    onClick={() =>  handleOddsClick(market, 'yes')}
                  >
                    <span className="odds">{market.runsYes}</span>
                    <span className="volume">{market.oddsYes}</span>
                  </OddsBox>
                </OddsContainer>
              </MarketRow>

              {/* --- NO slip --- */}
              {selectedBets[noKey] && (
                <BetSlip type="no">
                  <BetInputContainer>
                    <OddsDisplay>{`${market.runsNo}`}</OddsDisplay>
                    <AmountContainer>
                      <AdjustButton
                        onClick={() =>
                          setBetAmounts(prev => ({
                            ...prev,
                            [noKey]: handleAmountChange(prev[noKey], -100),
                          }))
                        }
                      >
                        -
                      </AdjustButton>
                    <AmountInput
  type="number"
  value={betAmounts[noKey] || ''}
  onChange={(e) =>
    handleAmountChange(noKey, parseFloat(e.target.value) || 0)
  }
/>
                      <AdjustButton
                        onClick={() =>
                          setBetAmounts(prev => ({
                            ...prev,
                            [noKey]: handleAmountChange(prev[noKey], +100),
                          }))
                        }
                      >
                        +
                      </AdjustButton>
                    </AmountContainer>
                  </BetInputContainer>

                  <QuickAmounts>
                    {quickAmounts.map(amount => (
                      <QuickAmount
                        key={amount}
                        onClick={() =>
                          setBetAmounts(prev => ({
                            ...prev,
                            [noKey]: String(amount),
                          }))
                        }
                      >
                        {amount}
                      </QuickAmount>
                    ))}
                  </QuickAmounts>

                  <Numpad>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 0, '00', '×'].map((num, i) => (
                      <NumpadButton
                        key={i}
                        onClick={() => {
                          if (num === '×') {
                            setBetAmounts(prev => ({ ...prev, [noKey]: '0' }));
                          } else {
                            setBetAmounts(prev => {
                              const curr = String(prev[noKey] ?? '0');
                              const next = curr === '0' ? String(num) : curr + String(num);
                              const safe = /^\d+$/.test(next) ? next : '0';
                              return { ...prev, [noKey]: safe };
                            });
                          }
                        }}
                      >
                        {num}
                      </NumpadButton>
                    ))}
                  </Numpad>

                  <ActionButtons>
                    <Button
                      onClick={() =>
                        setSelectedBets(prev => {
                          const next = { ...prev };
                          delete next[noKey];
                          return next;
                        })
                      }
                      style={{ opacity: placingKeys[noKey] ? 0.6 : 1, pointerEvents: placingKeys[noKey] ? 'none' : 'auto' }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="primary"
                      onClick={async () => {
                        // Prevent duplicate placement for this slip
                        if (placingKeys[noKey]) {
                          console.warn('Placement already in progress for', noKey);
                          return;
                        }

                        const stake = parseFloat(betAmounts[noKey] || '0');
                        const oddsNum = parseFloat(market.runsNo || '0');
                        if (!stake || stake < 4 || !oddsNum || oddsNum <= 0) {
                          sendNotfication('Enter valid stake (>=4) and odds (>0).', 'error', 'bottom-left');
                          return;
                        }
                        if (!matchData || !matchData.id || !matchData.team1 || !matchData.team2) {
                          sendNotfication('Match matchData missing', 'error', 'bottom-left');
                          return;
                        }

                        const betRow = {
                          market: 'FAN',
                          matchId: matchData.id,
                          matchTitle: `${matchData.team1} v ${matchData.team2}`,
                          selectionName: `${market.marketName} - No`,
                          category: 'fancy',
                          marketName: market.marketName,
                          type: 'no',
                          odds: oddsNum,
                          stake,
                          liability: stake ,
                          eventid: matchData.eventid,
                          acceptAnyOdds: !!acceptAnyOdds[noKey],
                        };

                        // set lock
                        setPlacingKeys(prev => ({ ...prev, [noKey]: true }));
                        try {
                          const result = await placeBets([betRow]);
                          if (result?.confirmed?.length > 0) {
                            sendNotfication('Bets placed successfully!', 'success', 'bottom-left');
                            setSelectedBets(prev => {
                              const next = { ...prev };
                              delete next[noKey];
                              return next;
                            });
                          } else {
                            sendNotfication(result?.errors?.[0]?.message || 'Bet placement failed', 'error', 'bottom-left');
                          }
                        } catch (err) {
                          console.error('Error placing fancy NO bet:', err);
                          sendNotfication('An unexpected error occurred while placing the bet.', 'error', 'bottom-left');
                        } finally {
                          // release lock
                          setPlacingKeys(prev => {
                            const copy = { ...prev };
                            delete copy[noKey];
                            return copy;
                          });
                        }
                      }}
                      style={{ opacity: placingKeys[noKey] ? 0.6 : 1, pointerEvents: placingKeys[noKey] ? 'none' : 'auto' }}
                    >
                      {placingKeys[noKey] ? 'Placing...' : 'Place Bet'}
                    </Button>
                  </ActionButtons>
{/* 
                  <AcceptOddsContainer>
                    <input
                      type="checkbox"
                      checked={!!acceptAnyOdds[noKey]}
                      onChange={() =>
                        setAcceptAnyOdds(prev => ({
                          ...prev,
                          [noKey]: !prev[noKey],
                        }))
                      }
                    />
                    <span>Accept Any Odds</span>
                  </AcceptOddsContainer> */}
                </BetSlip>
              )}

              {/* --- YES slip --- */}
              {selectedBets[yesKey] && (
                <BetSlip type="yes">
                  <BetInputContainer>
                    <OddsDisplay>{`${market.runsYes}`}</OddsDisplay>
                    <AmountContainer>
                      <AdjustButton
                        onClick={() =>
                          setBetAmounts(prev => ({
                            ...prev,
                            [yesKey]: handleAmountChange(prev[yesKey], -100),
                          }))
                        }
                      >
                        -
                      </AdjustButton>
                     <AmountInput
  type="number"
  value={betAmounts[yesKey] || ''}
  onChange={(e) =>
    handleAmountChange(yesKey, parseFloat(e.target.value) || 0)
  }
/>
                      <AdjustButton
                        onClick={() =>
                          setBetAmounts(prev => ({
                            ...prev,
                            [yesKey]: handleAmountChange(prev[yesKey], +100),
                          }))
                        }
                      >
                        +
                      </AdjustButton>
                    </AmountContainer>
                  </BetInputContainer>

                  <QuickAmounts>
                    {quickAmounts.map(amount => (
                      <QuickAmount
                        key={amount}
                        onClick={() =>
                          setBetAmounts(prev => ({
                            ...prev,
                            [yesKey]: String(amount),
                          }))
                        }
                      >
                        {amount}
                      </QuickAmount>
                    ))}
                  </QuickAmounts>

                  <Numpad>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 0, '00', '×'].map((num, i) => (
                      <NumpadButton
                        key={i}
                        onClick={() => {
                          if (num === '×') {
                            setBetAmounts(prev => ({ ...prev, [yesKey]: '0' }));
                          } else {
                            setBetAmounts(prev => {
                              const curr = String(prev[yesKey] ?? '0');
                              const next = curr === '0' ? String(num) : curr + String(num);
                              const safe = /^\d+$/.test(next) ? next : '0';
                              return { ...prev, [yesKey]: safe };
                            });
                          }
                        }}
                      >
                        {num}
                      </NumpadButton>
                    ))}
                  </Numpad>

                  <ActionButtons>
                    <Button
                      onClick={() =>
                        setSelectedBets(prev => {
                          const next = { ...prev };
                          delete next[yesKey];
                          return next;
                        })
                      }
                      style={{ opacity: placingKeys[yesKey] ? 0.6 : 1, pointerEvents: placingKeys[yesKey] ? 'none' : 'auto' }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="primary"
                      onClick={async () => {
                        // Prevent duplicate placement for this slip
                        if (placingKeys[yesKey]) {
                          console.warn('Placement already in progress for', yesKey);
                          return;
                        }

                        const stake = parseFloat(betAmounts[yesKey] || '0');
                        const oddsNum = parseFloat(market.runsYes || '0');
                        if (!stake || stake < 4 || !oddsNum || oddsNum <= 0) {
                          sendNotfication('Enter valid stake (>=4) and odds (>0).', 'error', 'bottom-left');
                          return;
                        }
                        if (!matchData || !matchData.id || !matchData.team1 || !matchData.team2) {
                          sendNotfication('Match matchData missing', 'error', 'bottom-left');
                          return;
                        }

                        const betRow = {
                          market: 'FAN',
                          matchId: matchData.id,
                          matchTitle: `${matchData.team1} v ${matchData.team2}`,
                          selectionName: `${market.marketName} - Yes`,
                          marketName: market.marketName,
                          category: 'fancy',
                          type: 'yes',
                          odds: oddsNum,
                          stake,
                          liability: stake ,
                          eventid: matchData.eventid,
                          acceptAnyOdds: !!acceptAnyOdds[yesKey],
                        };

                        // set lock
                        setPlacingKeys(prev => ({ ...prev, [yesKey]: true }));
                        try {
                          const result = await placeBets([betRow]);
                          if (result?.confirmed?.length > 0) {
                            sendNotfication('Bets placed successfully!', 'success', 'bottom-left');
                            setSelectedBets(prev => {
                              const next = { ...prev };
                              delete next[yesKey];
                              return next;
                            });
                          } else {
                            sendNotfication(result?.errors?.[0]?.message || 'Bet placement failed', 'error', 'bottom-left');
                          }
                        } catch (err) {
                          console.error('Error placing fancy YES bet:', err);
                          sendNotfication('An unexpected error occurred while placing the bet.', 'error', 'bottom-left');
                        } finally {
                          // release lock
                          setPlacingKeys(prev => {
                            const copy = { ...prev };
                            delete copy[yesKey];
                            return copy;
                          });
                        }
                      }}
                      style={{ opacity: placingKeys[yesKey] ? 0.6 : 1, pointerEvents: placingKeys[yesKey] ? 'none' : 'auto' }}
                    >
                      {placingKeys[yesKey] ? 'Placing...' : 'Place Bet'}
                    </Button>
                  </ActionButtons>

                  {/* <AcceptOddsContainer>
                    <input
                      type="checkbox"
                      checked={!!acceptAnyOdds[yesKey]}
                      onChange={() =>
                        setAcceptAnyOdds(prev => ({
                          ...prev,
                          [yesKey]: !prev[yesKey],
                        }))
                      }
                    />
                    <span>Accept Any Odds</span>
                  </AcceptOddsContainer> */}
                </BetSlip>
              )}
            </React.Fragment>
          );
        })}
      </MarketContainer>
    </Container>
  );
};

export default FancyBetMobile;
